
const messages = () => {

	const $window = window;

	const Notify = function(type, text) {

		let icon = '';

		// switch(type){
		// 	case 'success':
		// 		icon = '<i class="fas fa-check toast-message-icon"></i> ';
		// 	break;

		// 	case 'error':
		// 		icon = '<i class="fas fa-exclamation-triangle toast-message-icon"></i> ';
		// 	break;

		// 	case 'info':
		// 		icon = '<i class="fas fa-question-circle toast-message-icon"></i> ';
		// 	break;

		// 	case 'warning':
		// 		icon = '<i class="fas fa-exclamation-triangle toast-message-icon"></i> ';
		// 	break;
		// }

		toastr.options = {
	                    "closeButton": true,
	                    "newestOnTop": false,
	                    "preventDuplicates": true,
	                    "positionClass": "toast-bottom-right",
	                    "showDuration": "1000",
	                    "hideDuration": "5500",
	                    "timeOut": "5500",
	                    "extendedTimeOut": "1000"
	                };
	    
	    if(toastr[type])
	    	toastr[type](icon + text);

	};

	$window.push_alert = function(msg) {
		Notify('info', msg);
	};

	$window.push_success = function(msg) {
		Notify('success', msg);
	};

	$window.push_error = function(msg) {
		Notify('error', msg);
	};

	$window.push_warning = function(msg) {
		Notify('warning', msg);
	};

	$window.push_info = function(msg) {
		Notify('info', msg);
	};

	$window.show_loading = function() {
		Notify('info', "Cargando...");
	};

	$window.hide_loading = function() {
		toastr.clear();
	};

}

export { messages }